<template>
  <div>
    <el-select
      v-model="channelId"
      :disabled="disabled"
      :placeholder="placeholder"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      channelId: "", // 当前被选择的渠道id
      availableChannels: [], // 所有可用的渠道
    };
  },

  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    // 是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },

    // 是否支持选择“全渠道”
    enableFullChannels: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    options() {
      let options = [];

      for (let c of this.availableChannels) {
        if (c.id == 0 && !this.enableFullChannels) {
          continue;
        }

        options.push({
          id: c.id,
          name: c.name,
        });
      }

      return options;
    },
  },

  created() {
    this.loadAvailableChannels();
  },

  watch: {
    channelId: {
      handler(newValue, oldValue) {
        this.$emit("change", newValue, oldValue);
      },
    },
  },

  methods: {
    /**
     * 查询渠道集合
     */
    async loadAvailableChannels() {
      this.availableChannels = await bizutil.loadAvailableChannels();

      // 抛出准备就绪事件
      this.$emit("ready");
    },
  },
};
</script>